import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import styled from 'styled-components';

interface Props extends NavLinkProps {
	isSmallScreen?: boolean;
	isTop?: boolean;
	isBottom?: boolean;
}

const MenuLink = ({ isSmallScreen = false, ...rest }: Props) => (
	<StyledNavLink $isSmallScreen={isSmallScreen} {...rest} />
);

const StyledNavLink = styled(NavLink)<{ $isSmallScreen: boolean }>`
	display: flex;
	align-items: center;
	height: 55px;
	line-height: 45px;
	font-size: ${({ $isSmallScreen }) => ($isSmallScreen ? '14px' : '18px')};
	padding: ${({ $isSmallScreen }) => ($isSmallScreen ? '5px 5px 5px 20px' : '5px 15px 5px 25px')};
	background-color: ${({ theme }) => theme.colors.darkGreyR};
	${({ $isSmallScreen }) => $isSmallScreen && 'margin: 1px 5px;'};

	&:hover {
		color: ${({ theme }) => theme.colors.darkGreyR};
		background-color: ${({ theme }) => theme.colors.white};

		span {
			color: ${({ theme }) => theme.colors.darkGreyR};
		}
	}
`;

export default MenuLink;
